import React, { useEffect, useState, useContext } from "react";
import DonationSchedule from "../../../components/Schedules/Others/DonationSchedule";
import { initSchedule } from "../../../utils/data/initData";
import { AuthContext } from "../../../contexts/AuthContext";
import { useErrorDialog } from "../../../contexts/ErrorDialogContext";
import { useSuccessDialog } from "../../../contexts/SuccessDialogContext";
import ComponentLoading from "../../../components/App/ComponentLoading";
import { PL_SCHEDULES } from "../../../utils/data/controlData";
import { handleScheduleDeletion } from "../utils/handleScheduleDeletion";
import { useAccessControl } from "../../../utils/hooks/useAccessControl";

const DonationSchedulePage = ({ company, scheduleId }) => {
  const { updatePLSchedule, getScheduleData, deleteScheduleByScheduleType } =
    useContext(AuthContext);
  const handleSuccess = useSuccessDialog();
  const handleError = useErrorDialog();

  const { canEdit: canEditPLSchedule } = useAccessControl(PL_SCHEDULES);

  const [saveTrigger, setSaveTrigger] = useState(false);
  const [schedule, setSchedule] = useState({});
  const [scheduleDetails, setScheduleDetails] = useState({});

  const [loading, setLoading] = useState(true);

  const saveSchedule = async (schedule, scheduleDetails) => {
    if (!company || !scheduleId) {
      handleError("Unexpected error happens. Please try again later.");
      return;
    }

    const updatedSchedule = {
      sch_id: scheduleId,
      scheduleType: "Donation",
      scheduleTitle: schedule.name,
      additionDeduction: scheduleDetails.additionDeduction,
      donationRows: scheduleDetails.donationRows,
      notes: schedule.notes,
      reviewNotes: schedule.reviewNotes,
      totalAdjustment: scheduleDetails.totalAdjustment,
      doc: scheduleDetails.doc,
    };

    setLoading(true);
    const response = await updatePLSchedule(updatedSchedule);
    setLoading(false);

    if (response) {
      handleSuccess("The schedule has been saved successfully.");
      setSaveTrigger((prev) => !prev);
    } else {
      handleError(
        "There was a problem saving the schedule. Please contact support if the issue persists."
      );
    }
  };

  const deleteSchedule = async () => {
    await handleScheduleDeletion({
      scheduleId,
      deleteFn: deleteScheduleByScheduleType,
      handleSuccess,
      handleError,
      setLoading,
    });
  };

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      if (!company || !scheduleId) {
        handleError(
          "We encountered an issue while fetching the data. Please refresh the page or try again shortly."
        );
        return;
      }

      //API call here
      const response = await getScheduleData(scheduleId, 'Donation');

      const scheduleData = response.schedule;

      //init
      if (scheduleData) {
        setSchedule(initSchedule(scheduleData, "Qualifying Donations"));
        setScheduleDetails({
          donationRows: scheduleData.donationRows.filter(
            (item) => !item.status || item.status !== "autoload"
          ),
          sourceData: scheduleData.donationRows.filter(
            (item) => item.status && item.status === "autoload"
          ),
          additionDeduction: scheduleData.additionDeduction,
        });
      }

      setLoading(false);
    };

    fetchData();
  }, [saveTrigger, scheduleId, company.uen, getScheduleData, updatePLSchedule]);

  return (
    <>
      {!loading ? (
        <DonationSchedule
          company={company}
          schedule={schedule}
          scheduleDetails={scheduleDetails}
          saveSchedule={saveSchedule}
          deleteSchedule={deleteSchedule}
          canEditSchedule={canEditPLSchedule}
        />
      ) : (
        <ComponentLoading />
      )}
    </>
  );
};

export default DonationSchedulePage;
